import { createFileRoute } from "@tanstack/react-router";

import { NetworkSettingsPanel } from "../components/settings/NetworkSettings";
import { redirectUnlessOfferedOnClient } from "../components/settings/settingsClientBridges";

function SettingsNetworkRoute() {
  const { machine, add } = Route.useSearch();
  return (
    <NetworkSettingsPanel
      {...(machine ? { address: machine } : {})}
      {...(add ? { adding: add } : {})}
    />
  );
}

export const Route = createFileRoute("/settings/network")({
  // Keyed off the Connect bridge, not `isElectron`: where there is no bridge there is nothing to
  // sign into. Configured browser clients use the same account surface as Desktop.
  beforeLoad: () => redirectUnlessOfferedOnClient("/settings/network"),
  // `machine` opens one machine's page; `add` opens renting or adding a machine on the list.
  validateSearch: (
    raw: Record<string, unknown>,
  ): { machine?: string; add?: "rent" | "self-hosted" } => ({
    ...(typeof raw.machine === "string" && raw.machine.trim() ? { machine: raw.machine } : {}),
    ...(raw.add === "rent" || raw.add === "self-hosted" ? { add: raw.add } : {}),
  }),
  component: SettingsNetworkRoute,
});
